import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NaveBare = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("mobile-menu-visible");
    } else {
      document.body.classList.remove("mobile-menu-visible");
    }

    return () => {
      document.body.classList.remove("mobile-menu-visible");
    };
  }, [isMobileMenuOpen]);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <div>
      <button className="scroll__top scroll-to-target" data-target="html">
        <i className="tg-flaticon-arrowhead-up"></i>
      </button>

      <header>
        {/* ================= TOP HEADER ================= */}
        <div className="tg-header__top">
          <div className="container custom-container">
            <div className="row">
              <div className="col-lg-6">
                <ul className="tg-header__top-info list-wrap">
                  <li>
                    <img src="assets/img/icons/map_marker.svg" alt="Icon" />
                    <span>
                      1er étage, IMMEUBLE TAOUYA, En Face Maison Des Jeunes De
                      Ratoma, Conakry, Guinée
                    </span>
                  </li>
                  <li>
                    <img src="assets/img/icons/envelope.svg" alt="Icon" />
                    <a href="mailto:info@dvelgegroup.com">
                      info@dvelgegroup.com
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-6">
                <div className="tg-header__top-right">
                  <div className="tg-header__phone">
                    <img src="assets/img/icons/phone.svg" alt="Icon" />
                    appelez-nous: <a href="tel:623300992">+224 623300992</a>
                  </div>

                  <ul className="tg-header__top-social list-wrap">
                    <li>Suivez-nous :</li>

                    <li>
                      <a
                        href="https://www.facebook.com/dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://x.com/dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.instagram.com/dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.linkedin.com/company/dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://tiktok.com/@dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-tiktok"></i>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.youtube.com/@dvelgegroup"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= MAIN HEADER ================= */}
        <div id="header-fixed-height"></div>

        <div id="sticky-header" className="tg-header__area">
          <div className="container custom-container">
            <div className="row">
              <div className="col-12">
                <div className="tgmenu__wrap">
                  <nav className="tgmenu__nav">
                    <div className="logo">
                      <Link to="/">
                        <img src="assets/img/logo/logo.png" alt="Logo" />
                      </Link>
                    </div>

                    <div className="tgmenu__navbar-wrap tgmenu__main-menu d-none d-xl-flex">
                      <ul className="navigation">
                        <li>
                          <Link to="/">ACCUEIL</Link>
                        </li>
                        <li>
                          <Link to="/courses">COURS</Link>
                        </li>
                        <li>
                          <Link to="/formation-sur-mesure">
                            FORMATION SUR MESURE
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* Mobile Toggle */}
                    <div
                      className="mobile-nav-toggler"
                      onClick={() => setIsMobileMenuOpen(true)}
                    >
                      <i className="tg-flaticon-menu-1"></i>
                    </div>
                  </nav>
                </div>

                {/* ================= MOBILE MENU ================= */}
                <div className="tgmobile__menu">
                  <nav className="tgmobile__menu-box">
                    <div className="close-btn" onClick={closeMenu}>
                      <i className="tg-flaticon-close-1"></i>
                    </div>

                    <div className="nav-logo">
                      <Link to="/" onClick={closeMenu}>
                        <img src="assets/img/logo/logo.png" alt="Logo" />
                      </Link>
                    </div>

                    <div className="tgmobile__menu-outer">
                      <ul className="navigation">
                        <li>
                          <Link to="/" onClick={closeMenu}>
                            Accueil
                          </Link>
                        </li>
                        <li>
                          <Link to="/courses" onClick={closeMenu}>
                            Cours
                          </Link>
                        </li>
                        <li>
                          <Link to="/formation-sur-mesure" onClick={closeMenu}>
                            Formation Sur Mesure
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* Mobile Social Links */}
                    <div className="social-links">
                      <ul className="list-wrap">
                        <li>Suivez-nous :</li>

                        <li>
                          <a
                            href="https://www.facebook.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://x.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-twitter"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://www.instagram.com/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://www.linkedin.com/company/dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-linkedin-in"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://tiktok.com/@dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-tiktok"></i>
                          </a>
                        </li>

                        <li>
                          <a
                            href="https://www.youtube.com/@dvelgegroup"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                {/* Backdrop */}
                <div
                  className="tgmobile__menu-backdrop"
                  onClick={closeMenu}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NaveBare;
